// The backdrop behind the login and loading screens.
//
// A dark field ruled with a grid of dots, a soft glow behind whatever sits
// in the middle, and nothing that moves. Both screens share one, so
// arriving in the world is a continuation of the same surface rather than
// a cut to another picture.
//
// It is plain CSS on purpose. A canvas here would want an animation frame,
// and the WebGPU renderer starting up behind these screens should not be
// competing with the backdrop for either the graphics card or the clock.

export class Backdrop {
  readonly root: HTMLElement;

  constructor() {
    this.root = document.createElement("div");
    this.root.className = "backdrop";
    // Bottom to top: a wash of colour so the dark is not flat black, a
    // glow where the eye goes, then the dots over both. Painting the wash
    // last put it on top of the grid and swallowed it.
    for (const part of ["tint", "glow", "dots"]) {
      const layer = document.createElement("i");
      layer.className = part;
      this.root.append(layer);
    }
  }

  /** Kept so the screens can treat this like anything else they own. */
  start(): void {}

  stop(): void {}

  dispose(): void {}
}
